// Read-only field display for view modes
import type { ReactNode } from 'react';

export interface FieldDisplayProps {
  label: string;
  value: ReactNode;
  required?: boolean;
}

export function FieldDisplay({ label: _label, value, required: _required }: FieldDisplayProps) {
  const isEmpty = value === null || value === undefined || value === '';

  return (
    <div className="form-control">
      {/*<Label required={_required}>{_label}</Label>*/}
      <p className="px-4 py-3 bg-base-200 rounded-lg min-h-[48px]">
        {isEmpty ? <span className="text-base-content/50">—</span> : value}
      </p>
    </div>
  );
}
